/* 
  this is the base class for each parallax pump (acid, base, feed, antifoam, etc.)
  it implements all the required features 
  in its descendant classes you only specify its name/purpose/type (acid, base, feed, antifoam, etc.)
*/

import template	from "./dialog-config.html";
import css		from "./dialog-config.css";

import Dialog	from "dialog";
import {Label}  from "gui";
import sleep	from "sleep";


class ConfigParallaxPumpDialog extends Dialog {
  static get template() {
    return template;
  }
  static get css() {
    return css;
  }
  static constructor() {
    customElements.define("fulljs-dialog-config-parallax-pump", ConfigParallaxPumpDialog);
  }
  constructor(...args) {
    super(...args);

    this.show();
  }
  connectedCallback() {
    super.connectedCallback();

    this.onupdatedevices_handler_f = this.onupdatedevices_handler.bind(this);
    document.addEventListener("onupdatedevices", this.onupdatedevices_handler_f);

    this.onupdatedevices_handler({detail: application.devices});

    this.spinnerTargetRPM.value = this.textboxCurrentRPM.value;
    this.spinnerTargetMLH.value = this.textboxCurrentMLH.value;        
  }
  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener("onupdatedevices", this.onupdatedevices_handler_f);
  }
  buttonClose_click() {
    this.close();
  }
  onupdatedevices_handler(event) {
    var devices = event.detail;

    this.textboxDeviceID.value = devices[this.name].id;
    this.textboxDeviceStatus.value = devices[this.name].status;
    this.textboxCurrentRPM.value = devices[this.name].rpm;
    this.textboxCurrentMLH.value = devices[this.name].mlh;
    this.textboxCalibrationStatus.value = devices[this.name].calibrationStatus;
    this.spinnerSumML.value = Math.round(parseFloat(devices[this.name].sumML)*10)/10;
  }
  async spinnerTargetRPM_change() {
    try {
      await server.rcall(`RM_${this.endpoint}_setRPM`, this.spinnerTargetRPM.value);
    } catch(e) {
      error(e);
    }
  }
  async spinnerTargetMLH_change() {
    try {
      await server.rcall(`RM_${this.endpoint}_setMLH`, this.spinnerTargetMLH.value);
    } catch(e) {
      error(e);
    }
  }
  async buttonCalibrate_click() {
    try {     
      this.buttonCalibrate.icon.style.animationName = "spin";
      this.buttonCalibrate.icon.iconname = "view-refresh";
      await server.rcall(`RM_${this.endpoint}_calibrate`, this.spinnerCalibrationRPM.value, this.spinnerCalibrationMLH.value);
      this.buttonCalibrate.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonCalibrate.icon.iconname = "process-stop";
    } finally {
      this.buttonCalibrate.icon.style.animationName = "";
      await sleep(2000);
      this.buttonCalibrate.icon.iconname = "dialog-ok";
    }
  }
  async buttonClearSum_click() {
    try {          
      this.buttonClearSum.icon.style.animationName = "spin";
      this.buttonClearSum.icon.iconname = "view-refresh";
      await server.rcall(`RM_${this.endpoint}_clearsum`);
      this.buttonClearSum.icon.iconname = "dialog-ok-apply";
    } catch(e) {
      this.buttonClearSum.icon.iconname = "process-stop";
    } finally {
      this.buttonClearSum.icon.style.animationName = "";
      await sleep(2000);
      this.buttonClearSum.icon.iconname = "dialog-ok";
    }
  }    
  set endpoint(value) {
    this.__endpoint = value;
  }
  get endpoint() {
    return this.__endpoint;
  }
  set name(value) {
    this.__name = value;
    this.appendChild( new Label({
      slot: "header",
      value: `Config - ${value}`
    }) );
  }
  get name() {
    return this.__name;
  }
}

ConfigParallaxPumpDialog.constructor();

export default ConfigParallaxPumpDialog;